<template>
    <div class="hero featured-post is-white">
        <div class="hero-body">
            <div class="columns" v-if="post">
                <div class="column is-half-tablet is-4-desktop">
                    <div class="info">

                        <div class="details">
                            <div class="tag is-primary is-medium is-radiusless">Fremhævet indlæg</div>
                            <br>
                            <br>
                            <h2 class="title is-3 is-spaced has-text-weight-normal">
                                <router-link :to="{ name: 'blog.post', params: { slug: post.slug } }">
                                    {{ post.title.rendered }}
                                </router-link>
                            </h2>

                            <div v-html="post.excerpt.renderedShort"></div>
                        </div>

                        <div class="media-box">
                            <div class="media">
                                <div class="media-left">
                                    <figure class="image is-48x48 is-rounded">
                                        <img class="is-rounded" :src="post.author_data.avatar" alt="Placeholder image">
                                    </figure>
                                </div>

                                <div class="media-content">
                                    <p class="title is-6">{{post.author_data.name}}</p>
                                    <p class="subtitle is-6 has-text-primary">{{post.author_data.title}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="column">
                    <figure class="image">
                        <router-link :to="{ name: 'blog.post', params: { slug: post.slug } }">
                            <img :src="post.images.large" :alt="post.title.rendered">
                        </router-link>
                    </figure>
                </div>
            </div>

            <div class="has-text-centered" v-else>
                <span>Indlæser...</span><br>
                <b-icon icon="loading" custom-class="mdi-spin" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .featured-post {
        .hero-body {
            padding: 1.5rem;
        }

        .info {
            display: flex;
            flex-direction: column;
            height: 100%;

            .media-box {
                padding-top: 1rem;
                margin-top: auto;
            }

            .details {
                .title {
                    a {
                        color: $black;

                        &:hover {
                            color: $primary;
                        }
                    }
                }
            }
        }

        .image img {
            max-height: 350px;
            object-fit: cover;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                post: null,
                featuredTagId: 14,
            };
        },

        mounted() {
            this.$store.dispatch('blog/fetchPostsForTag', {
                id: this.featuredTagId,
            }).then((posts) => {
                // eslint-disable-next-line prefer-destructuring
                this.post = posts[0];
            });
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/components/FeaturedPost.vue